//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { ThresholdFailedConfirmationModalAction } from '@catalog-ingestion/actions/thresholdFailedConfirmationModalActions';
import { THRESHOLD_FAILED_CONFIRMATION_MODAL_ACTIONS } from '@catalog-ingestion/constants/thresholdFailedConfirmationModalConstants';
import { IThresholdFailedConfirmationModalState } from '@catalog-ingestion/models/ThresholdFailedConfirmationModalModel';

const initialState: IThresholdFailedConfirmationModalState = {
  isOpen: false,
};

export default function ExitConfirmationModalReducer(
  state: IThresholdFailedConfirmationModalState = initialState,
  action: ThresholdFailedConfirmationModalAction,
): IThresholdFailedConfirmationModalState {
  switch ( action.type ) {
    case THRESHOLD_FAILED_CONFIRMATION_MODAL_ACTIONS.OPEN_MODAL:
      return {
        ...state,
        isOpen: true,
      };
    case THRESHOLD_FAILED_CONFIRMATION_MODAL_ACTIONS.CLOSE_MODAL:
      return {
        ...state,
        isOpen: false,
      };
    default:
      return state;
  }
}
